import _ from "lodash";
import React, { useState, useEffect, useRef } from "react";
import "../producto.css";
import "../producto-seccionado.css";
import { icons } from "icons";
import { connect } from "react-redux";
import LoadMask from "Utils/LoadMask/LoadMask";
import { CAPACIDAD, PESO, LONGITUD } from "utility/variables";
import FraccionesComponent from "../Fraccion/FraccionContainer";
import FileUploader from "../../Utils/FileUploader/FileUploader";
import Select from "react-select";
import { change  } from "redux-form";
import ModalVideo from "../../../components/Utils/Ayuda/ModalVideo";
import Swal from "sweetalert2";



import { Field, reduxForm, formValueSelector, FieldArray } from "redux-form";
import {
    renderField,
    renderTextArea,
    renderNumber,
    renderCurrency,
    renderPorcentaje,
    renderSearchSelect,
} from "Utils/renderField/renderField";
import { RenderCurrency as RCurrency } from "Utils/renderField/renderReadField";
import Catalogo from "../Crear/Catalogo";
import TreeCategoria from "../TreeCategoria";
import { preciosSucursal } from "../camposProducto";

import { mostrarSwalDescontinuar, mostrarSwalReactivar } from "Utils/Acciones/Acciones";

import TipoProductoTab from "./TipoProductoTab";

import SettingToggle from "../../../components/Utils/Ayuda/SettingToggle";
import ModalCarrusel from "../../../components/Utils/Ayuda/ModalCarrusel";



// VALIDACIONES CUSTOMS
const validate = (values) => {
    const errors = {};
    if (!values.nombre) errors.nombre = "Campo requerido";
    if (!values.descripcion) errors.descripcion = "Campo requerido";

    if (values.tipo_producto != "100") {
        if (!values.precio && values.precio != "0")
            errors.precio = "Campo requerido";
        if (values.descripcion_codigo_barras) {
            if (values.descripcion_codigo_barras.length > 20)
                errors.descripcion_codigo_barras = "Debe tener 20 caracteres o menos.";
        }
    }
    
    if (!values.inventariable) {
        values.alertar = false;
        values.minimo_existencias = null;
        values.tiene_fracciones = false;
    }
    
    if (values.alertar) {
        if (!values.minimo_existencias)
            errors.minimo_existencias = "Campo requerido";
    } else {
        values.minimo_existencias = null;
    }

    if (values.tienda_online) {
        if (!values.precio_online) {
            errors.precio_online = "Campo requerido";
        }
    }
    
    if (values.precios_sucursal) {
        if (values.precios_sucursal.length) {
            const preciosSucursalArrayErrors = [];
            values.precios_sucursal.forEach((precio_sucursal, index) => {
                const precioSucursalErrors = {};
                if (!precio_sucursal["precio"] && precio_sucursal["precio"] != "0")
                    precioSucursalErrors.precio = "Campo requerido";
                preciosSucursalArrayErrors[index] = precioSucursalErrors;
            });
            if (preciosSucursalArrayErrors.length)
                errors.precios_sucursal = preciosSucursalArrayErrors;
        }
    }

    if (values.codigos_barras && values.codigos_barras.length > 0) {
        const codigosBarrasArrayErrors = [];
        const codigosVistos = new Set();
        
        values.codigos_barras.forEach((name, index) => {
            const codigoErrors = {};
            if (name.codigo) {
                const codigo = name.codigo.trim();
                if (!/^\w+$/i.test(codigo)) {
                    codigoErrors.codigo = "Debe contener solo letras y/o números.";
                    codigosBarrasArrayErrors[index] = codigoErrors;
                } else if (codigosVistos.has(codigo)) {
                    codigoErrors.codigo = "Este código ya existe en la lista. No se permiten duplicados.";
                    codigosBarrasArrayErrors[index] = codigoErrors;
                } else {
                    codigosVistos.add(codigo);
                }
            }
        });
        
        if (codigosBarrasArrayErrors.length) {
            errors.codigos_barras = codigosBarrasArrayErrors;
        }
    }

    return errors;
};

const renderCurrencyStatic = ({ input }) => (
    <input
        type="text"
        className="form-control"
        value={input.value ? Number(input.value).toLocaleString('es-GT', {
            style: 'currency',
            currency: 'GTQ'
        }) : ''}
        disabled
    />
);

const renderCodigosBarras = ({ fields }) => {
    return (
        <div>
            {/* Única adición: Botón para cuando la lista está vacía */}
            {fields.length === 0 && (
                <button
                    type="button"
                    className="btn d-flex btn-no-shadow justify-content-center align-items-center"
                    onClick={() => fields.push({})}
                >
                    <img
                        src={require("../../../../../assets/img/icons/agregar.png")}
                        alt="Agregar"
                    />
                    <span className="ms-2">Agregar código de barras</span>
                </button>
            )}

            {fields.map((name, index) => (
                <div key={index} className="form-group d-flex align-items-center">
                    <Field
                        name={`${name}.codigo`}
                        component={renderField}
                        type="text"
                        className="form-control me-2"
                        placeholder="Ingrese código de barras"
                    />
                    {index === 0 ? (
                        <button
                            type="button"
                            className="btn d-flex btn-no-shadow justify-content-center align-items-center"
                            onClick={() => fields.push({})}
                        >
                            <img
                                src={require("../../../../../assets/img/icons/agregar.png")}
                                alt="Agregar"
                            />
                        </button>
                    ) : (
                        <button
                            type="button"
                            className="btn btn-no-shadow justify-content-center align-items-center"
                            onClick={() => fields.remove(index)}
                        >
                            <img
                                src={require("../../../../../assets/img/icons/eliminar.png")}
                                alt="Eliminar"
                            />
                        </button>
                    )}
                </div>
            ))}
        </div>
    );
};

const SECTIONS_BY_TIPO = {
    simple: [
        "datos-generales",
        "manejo-producto",
        "precios-generales",
        "precio-sucursal",
        "propiedades-producto",
        "resumen"
    ],
    medida: [
        "datos-generales",
        "propiedades-producto",
        "manejo-producto",
        "precios-generales",
        "precio-sucursal",
        "resumen"
    ],
    fraccionado: [
        "datos-generales",
        "propiedades-producto",
        "manejo-producto",
        "resumen"
    ],
};

const ALL_SECTIONS = [
    { id: "datos-generales", label: "Datos Generales", icon: "✓" },
    { id: "precios-generales", label: "Precios Generales", icon: "✓" },
    { id: "precio-sucursal", label: "Precio Sucursal", icon: "✓" },
    { id: "propiedades-producto", label: "Propiedades de producto", icon: "✓" },
    { id: "manejo-producto", label: "Manejo de producto", icon: "○" },
    { id: "resumen", label: "Resumen Final" }

];

const renderStaticNumber = ({ input, className }) => (
    <input 
        {...input} 
        type="number" 
        className={className} 
        disabled={true} 
        readOnly={true} 
        style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed' }}
    />
);

const Form = (props) => {
    const [selectedSection, setSelectedSection] = useState("datos-generales");
    const [tipoProducto, setTipoProducto] = useState("simple");
    
    const {
        unidades_de_medida_empresa,
        tipoProductoValue,
        fraccionadoValue,
        inventariableValue,
        alertaValue,
        unidadDeMedidaValue,
        seleccion_unidades_medida,
        foto_producto,
        conf_tienda_online,
        tienda_onlineValue,
        deBodega,
        loader,
        categorias,
        categorias_seleccionados,
        categoriaSelect,
        categorias_expanded,
        sucursales,
        sucursal,
        sucursal_activo,
        nombres_precios,
        conf_porcentaje_precio,
        conf_tipo_negocio,
        familias,
        getFamilias,
        precio2Value,
        precio3Value,
        precio4Value,
        precio5Value,
        precios_sucursalValue,
        kilataje,
        empresa,
        handleSubmit,
        editarProducto,
        onFileChange,
        cambioSeleccionUnidad,
        cambioTipoProducto,
        regresar,
        asignarCategoria,
        setCategoriasExpanded,
        changeSucursal,
        changeSucursalActivo,
        cambioPorcentajePrecio,
        producto,
        descontinuar,
        reactivar,
        existencias
    } = props;

    useEffect(function () {

        if (tipoProducto === "fraccionado" && tienda_onlineValue) {

            console.log("Desactivando tienda online porque es fraccionado");

            props.change("tienda_online", false);

        }

    }, [tipoProducto, tienda_onlineValue]);
    
    
    useEffect(function() {
            // Validamos que producto exista antes de leer sus propiedades
            if (producto && producto.id) {
                
                if (producto.tiene_fracciones) {
                    console.log("-----------------------------------");
                    console.log("Precargando: PRODUCTO FRACCIONADO");
                    console.log("ID:", producto.id);
                } 
                else if (producto.a_granel) {
                    console.log("-----------------------------------");
                    console.log("Precargando: PRODUCTO CON MEDIDA");
                    console.log("ID:", producto.id);
                } 
                else {
                    console.log("-----------------------------------");
                    console.log("Precargando: PRODUCTO SIMPLE");
                    console.log("ID:", producto.id);
                }
            }
        }, [producto]); // Observamos el objeto producto completo para evitar el error de .id


    // Efecto para PRE-CARGAR el tipo de producto basado en la API
    useEffect(function() {
        if (producto && producto.id) {
            var nuevoTipo = "simple";
            
            if (producto.tiene_fracciones) {
                nuevoTipo = "fraccionado";
            } else if (producto.a_granel) {
                nuevoTipo = "medida";
            }

            console.log("Sincronizando Tab de Edición a:", nuevoTipo);
            setTipoProducto(nuevoTipo);
        }
    }, [producto]);

    const tiendaOnlinePrevValue = useRef(null);

    useEffect(() => {
        const tiposMedida = ["1000", "2000", "3000"];
        const esMedida = tiposMedida.includes(tipoProductoValue);

        if (esMedida) {
            // Guardamos el valor anterior SOLO si no lo hemos guardado aún
            if (tiendaOnlinePrevValue.current === null) {
                tiendaOnlinePrevValue.current = tienda_onlineValue;
            }

            // Forzamos a false si estaba en true
            if (tienda_onlineValue) {
                props.change("tienda_online", false);
            }

        } else {
            // Si ya no es medida y teníamos un valor guardado, lo restauramos
            if (tiendaOnlinePrevValue.current !== null) {
                props.change("tienda_online", tiendaOnlinePrevValue.current);
                tiendaOnlinePrevValue.current = null; // limpiamos
            }
        }
    }, [tipoProductoValue]);


    const MANEJO_LABELS = {
        simple: "Manejo de producto simple",
        medida: "Manejo de producto con medida",
        fraccionado: "Manejo de producto fraccionado"
    };

    // Filtrar secciones dinámicamente según el tipo detectado
    const sections = ALL_SECTIONS
    .filter(section => SECTIONS_BY_TIPO[tipoProducto].includes(section.id))
    .map(section =>
        section.id === "manejo-producto"
            ? { ...section, label: MANEJO_LABELS[tipoProducto] }
            : section
    );

    // Función para cambiar tipo manualmente (opcional en editar, pero útil)
    const onChangeTipoProducto = (tipo) => {

        setTipoProducto(tipo);
        setSelectedSection(SECTIONS_BY_TIPO[tipo][0]);

        if (tipo === "simple") {

            props.change("tipo_producto", "1");   // CORRECTO
            props.change("tiene_fracciones", false);
            props.change("a_granel", false);

        }

        if (tipo === "medida") {

            props.change("tipo_producto", "1000"); // o el default que uses
            props.change("tiene_fracciones", false);
            props.change("a_granel", true);

        }

        if (tipo === "fraccionado") {

            props.change("tipo_producto", "100");  // FRACCIONADO
            props.change("tiene_fracciones", true);
            props.change("a_granel", false);

        }

    };



    // Unidades de medida por el tipo
    const unidades_medida = React.useMemo(() => {
        if (!tipoProductoValue) return [];
        let result = [];
        if (tipoProductoValue == "1000") result = _.filter(unidades_de_medida_empresa, u => u.tipo === PESO);
        else if (tipoProductoValue == "2000") result = _.filter(unidades_de_medida_empresa, u => u.tipo === CAPACIDAD);
        else if (tipoProductoValue == "3000") result = _.filter(unidades_de_medida_empresa, u => u.tipo === LONGITUD);
        return _.orderBy(result, ["capacidad"], ["asc"]);
    }, [tipoProductoValue, unidades_de_medida_empresa]);



    const kilatajes = [
        { label: "10k", value: 10 },
        { label: "14k", value: 14 },
        { label: "18k", value: 18 },
        { label: "21k", value: 21 },
        { label: "24k", value: 24 },
    ];

    useEffect(function () {

        if (
            tipoProducto === "medida" &&
            inventariableValue &&
            tienda_onlineValue &&
            unidades_medida &&
            unidades_medida.length > 0
        ) {

            // Si no hay valor en redux-form, usar el del producto o el primero
            if (!unidadDeMedidaValue) {

                const unidadInicial =
                    props.initialValues &&
                    props.initialValues.unidad_de_medida
                        ? props.initialValues.unidad_de_medida
                        : unidades_medida[0].id;

                console.log("Inicializando unidad en editar:", unidadInicial);

                props.change("unidad_de_medida", unidadInicial);
            }
        }

    }, [
        tipoProducto,
        inventariableValue,
        tienda_onlineValue,
        unidades_medida,
        unidadDeMedidaValue
    ]);


    // Función para obtener el icono de la sección basado en el progreso
    const getSectionIcon = (sectionId) => {
        const currentIndex = sections.findIndex(section => section.id === selectedSection);
        const sectionIndex = sections.findIndex(section => section.id === sectionId);
        
        if (sectionIndex < currentIndex) {
            return "✓"; // Completado
        } else if (sectionIndex === currentIndex) {
            return "●"; // Actual
        } else {
            return "○"; // Pendiente
        }
    };

    // Funciones de navegación
    const goToNextSection = () => {
        console.log('Intentando ir a la siguiente sección');
        const currentIndex = sections.findIndex(section => section.id === selectedSection);
        console.log('Sección actual:', selectedSection, 'Índice:', currentIndex);
        if (currentIndex < sections.length - 1) {
            const nextSection = sections[currentIndex + 1].id;
            console.log('Yendo a la siguiente sección:', nextSection);
            setSelectedSection(nextSection);
        } else {
            console.log('Ya estás en la última sección');
        }
    };

    const goToPreviousSection = () => {
        console.log('Intentando ir a la sección anterior');
        const currentIndex = sections.findIndex(section => section.id === selectedSection);
        console.log('Sección actual:', selectedSection, 'Índice:', currentIndex);
        if (currentIndex > 0) {
            const previousSection = sections[currentIndex - 1].id;
            console.log('Yendo a la sección anterior:', previousSection);
            setSelectedSection(previousSection);
        } else {
            console.log('Ya estás en la primera sección');
        }
    };

    // Verificar si se puede ir a la siguiente sección
    const canGoNext = () => {
        const currentIndex = sections.findIndex(section => section.id === selectedSection);
        return currentIndex < sections.length - 1;
    };

    // Verificar si se puede ir a la sección anterior
    const canGoPrevious = () => {
        const currentIndex = sections.findIndex(section => section.id === selectedSection);
        return currentIndex > 0;
    };

    //Metodo para ir a una seccion en especifico
    const goToSection = (sectionId) => {
        setSelectedSection(sectionId);
    };

    const renderSectionContent = () => {
        switch (selectedSection) {
            case "datos-generales":
                return <DatosGeneralesSection 
                    {...props}
                    tipoProducto={tipoProducto} 
                    onNext={goToNextSection} 
                    onPrevious={goToPreviousSection} 
                    canGoNext={canGoNext()} 
                    canGoPrevious={canGoPrevious()} 
                />;
            case "precios-generales":
                return <PreciosGeneralesSection 
                    {...props} 
                    onNext={goToNextSection} 
                    onPrevious={goToPreviousSection} 
                    canGoNext={canGoNext()} 
                    canGoPrevious={canGoPrevious()} 
                />;
            case "precio-sucursal":
                return <PrecioSucursalSection 
                    {...props} 
                    onNext={goToNextSection} 
                    onPrevious={goToPreviousSection} 
                    canGoNext={canGoNext()} 
                    canGoPrevious={canGoPrevious()} 
                />;
            case "propiedades-producto":
                return <PropiedadesProductoSection 
                    {...props} 
                    onNext={goToNextSection} 
                    onPrevious={goToPreviousSection} 
                    canGoNext={canGoNext()} 
                    canGoPrevious={canGoPrevious()}
                    descontinuar={descontinuar}
                    reactivar={reactivar} 
                />;
            case "manejo-producto":
                return <ManejoProductoSection 
                    {...props} 
                    onNext={goToNextSection} 
                    onPrevious={goToPreviousSection} 
                    canGoNext={canGoNext()} 
                    canGoPrevious={canGoPrevious()} 
                    unidades_medida={unidades_medida}
                />;
            case "resumen":
                return (
                    <ResumenSection
                        {...props}
                        tipoProducto={tipoProducto}
                        values={props.values}
                        onPrevious={goToPreviousSection}
                        canGoPrevious={canGoPrevious()}
                        unidades_medida={unidades_medida}
                        goToSection={goToSection}
                        onNext={handleSubmit(function(formValues) {
                            editarProducto();
                        })}
                    />
                );
            default:
                return <DatosGeneralesSection 
                    {...props} 
                    onNext={goToNextSection} 
                    onPrevious={goToPreviousSection} 
                    canGoNext={canGoNext()} 
                    canGoPrevious={canGoPrevious()} 
                />;
        }
    };

    return (
        <div className="grid-container mt0">
            <LoadMask loading={loader} dark blur>
                <TipoProductoTab
                    value={tipoProducto}
                    onChange={onChangeTipoProducto}
                    disabled={false}
                />
                <div className="grid-cuerpo padding-15 p-sm-0 pt-sm-1 pb-sm-1 mt">
                    <form>
                        <div className="row">
                            {/* Navegación lateral izquierda */}
                            <div className="col-md-3">
                                <div className="section-navigation">
                                    <h5 className="mb-3">Edición de producto</h5>
                                    {sections.map((section, index) => (
                                        <div
                                            key={section.id}
                                            className={`section-item ${selectedSection === section.id ? 'active' : ''}`}
                                            onClick={() => setSelectedSection(section.id)}
                                        >
                                            <div className="section-icon">
                                                {getSectionIcon(section.id)}
                                            </div>
                                            <div className="section-label">
                                                {section.label}
                                            </div>
                                            {index < sections.length - 1 && <div className="section-connector" />}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            
                            {/* Contenido de la sección seleccionada */}
                            <div className="col-md-9">
                                <div className="section-content">
                                    {renderSectionContent()}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

            </LoadMask>
        </div>
    );
};

// Componentes de sección
const DatosGeneralesSection = ({readOnlyMode = false, conf_tipo_negocio, kilataje, change, tipoProducto, onNext, onPrevious, canGoNext, canGoPrevious, onFileChange, foto_producto, conf_tienda_online, getFamilias, producto, ...rest }) => {

    const imagenAMostrar = foto_producto 
        ? (typeof foto_producto === 'string' ? foto_producto : URL.createObjectURL(foto_producto))
        : (producto && producto.imagen ? producto.imagen : null);

    const tiene_imagen = imagenAMostrar ? true : false;

    const catalogoVirtual = { ...producto };

    Object.keys(rest).forEach(key => {
        if (key.startsWith("catalogo_") && rest[key]) {
            const index = key.split("_")[1]; // Extrae el número (0, 1, 2...)
            const numeroImagen = parseInt(index) + 1; // El componente espera imagen_1, imagen_2...
            
            const data = rest[key];
            catalogoVirtual[`imagen_${numeroImagen}`] = (data instanceof File) 
                ? URL.createObjectURL(data) 
                : data;
        }
    });

    const totalImagenes = Object.keys(catalogoVirtual).filter(k => k.startsWith('imagen_')).length;
    const catalogoKey = `cat-${producto.id || 'nuevo'}-${totalImagenes}`;

    return (
        <div className="section-panel">
            <div className="section-header">
                <h4>Datos Generales</h4>
                {!readOnlyMode && (
                <div className="section-actions">
                    <button 
                        type="button" 
                        className="btn btn-secondary"
                        onClick={() => {
                            console.log('Botón Regresar clickeado');
                            onPrevious();
                        }}
                        disabled={!canGoPrevious}
                    >
                        Regresar
                    </button>
                    <button 
                        type="button" 
                        className="btn btn-primary"
                        onClick={() => {
                            console.log('Botón Siguiente clickeado');
                            onNext();
                        }}
                        disabled={!canGoNext}
                    >
                        Siguiente
                    </button>
                </div>
                )}
            </div>
            
            <div className={readOnlyMode ? "read-only-wrapper" : ""}>
            <div className="row">
                <div className="col-sm-6 content-drop-zone">
                    <div className="row">
                        <div className="col-12">
                            <FileUploader
                                onFileChange={onFileChange}
                                icono={"add-img"}
                                frase={"producto."}
                                clave={"foto_producto"}
                                width="100%"
                                source={imagenAMostrar} 
                                archivo={foto_producto}
                            />
                        </div>
                        <div className="col-12">
                            <div className="mb-2 my-2 text-center">
                                Fotos adicionales
                            </div>
                            <Catalogo
                                key={`cat-${producto.id || 'nuevo'}`}
                                disabled={tiene_imagen ? "" : true}
                                onFileChange={onFileChange}
                                catalogo={producto}
                                catalogo={catalogoVirtual}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="row-fields">
                        <div className="form-group">
                            <label htmlFor="nombre">Nombre *</label>
                            <Field
                                name="nombre"
                                component={renderField}
                                type="text"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="marca">Marca</label>
                            <Field
                                name="marca"
                                component={renderField}
                                type="text"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="familia">Familia</label>
                            <Field
                                name="familia"
                                component={renderSearchSelect}
                                loadOptions={getFamilias}
                                valueKey="id"
                                labelKey="nombre"
                                placeholder="Selecciona una familia"
                            />
                        </div>   

                        {(tipoProducto === "simple" || tipoProducto === "medida") && (
                            <div className="form-group">
                                <label htmlFor="codigos_barras">Código de barras</label>
                                <FieldArray
                                    name="codigos_barras"
                                    component={renderCodigosBarras}
                                />
                            </div>
                        )}


                        {(tipoProducto === "simple" || tipoProducto === "medida") && (
                            <div className="form-group">
                                <label htmlFor="descripcion_codigo_barras">
                                    Descripción código de barras
                                </label>
                                <Field
                                    name="descripcion_codigo_barras"
                                    component={renderField}
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                        )}

                        <div className="form-group">
                            <label htmlFor="descripcion">Descripción *</label>
                            <Field
                                name="descripcion"
                                component={renderTextArea}
                                className="form-control"
                            />
                        </div>

                        {conf_tipo_negocio === "Joyeria" && (
                            <div className="d-flex flex-wrap">
                                <div className="form-group col-sm-12 col-md-4">
                                    <label htmlFor="kilataje">Kilataje</label>
                                    <Select
                                        className="form-control"
                                        options={[
                                            { label: "9.25k", value: 9.25 },
                                            { label: "10k", value: 10 },
                                            { label: "14k", value: 14 },
                                            { label: "18k", value: 18 },
                                            { label: "21k", value: 21 },
                                            { label: "24k", value: 24 },
                                        ]}
                                        name="kilataje"
                                        value={
                                            kilataje
                                                ? { label: kilataje + "k", value: kilataje }
                                                : null
                                        }
                                        onChange={(selectedOption) => {
                                            change("kilataje", selectedOption.value);
                                        }}
                                    />
                                </div>

                                <div className="form-group col-sm-12 col-md-4">
                                    <label htmlFor="peso">Peso (Gramos)</label>
                                    <Field
                                        name="peso"
                                        component={renderField}
                                        type="number"
                                        className="form-control"
                                    />
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
            </div>
        </div>
    );
};

const PreciosGeneralesSection = ({readOnlyMode = false,  onNext, onPrevious, canGoNext, canGoPrevious, nombres_precios, conf_porcentaje_precio, cambioPorcentajePrecio, precio2Value, precio3Value, precio4Value, precio5Value, tienda_onlineValue }) => {
    
    return (
        <div className="section-panel">
            <div className="section-header">
                <h4>Precios Generales</h4>
                {!readOnlyMode && (
                <div className="section-actions">
                    <button 
                        type="button" 
                        className="btn btn-secondary"
                        onClick={() => {
                            console.log('Botón Regresar clickeado - Precios Generales');
                            onPrevious();
                        }}
                        disabled={!canGoPrevious}
                    >
                        Regresar
                    </button>
                    <button 
                        type="button" 
                        className="btn btn-primary"
                        onClick={() => {
                            console.log('Botón Siguiente clickeado - Precios Generales');
                            onNext();
                        }}
                        disabled={!canGoNext}
                    >
                        Siguiente
                    </button>
                </div>
                )}
            </div>

            <div className={readOnlyMode ? "read-only-wrapper" : ""}>
            <div className="section-header">
                    <h5>Precios Venta</h5>
                </div>
            
            <div className="row row-fields">
                

                <div className="w-100 text-muted small mb-2">
                    Estos son los precios de venta del producto.
                    Solo el primero es obligatorio; los demás son opcionales y se utilizarán
                    únicamente si tienen un valor mayor a cero.
                </div>

                <div className="w-100 text-muted small mb-3">
                    Puedes modificar los nombres de los precios según tus necesidades
                    (por ejemplo: mayorista, minorista, especial).
                </div>

                <div className="col-sm-12 col-md-2 col-lg-2 form-group">
                    {nombres_precios ? (
                        <label htmlFor="precio">{nombres_precios.nombre_precio} *</label>
                    ) : (
                        <label htmlFor="precio">Precio *</label>
                    )}
                    <Field
                        name="precio"
                        component={renderCurrency}
                        decimalScale={2}
                        type="number"
                        className="form-control"
                        onChange={(event) => {
                            setTimeout(() => {
                                cambioPorcentajePrecio("porcent_precio2", "ProductoEditar");
                                cambioPorcentajePrecio("porcent_precio3", "ProductoEditar");
                                cambioPorcentajePrecio("porcent_precio4", "ProductoEditar");
                                cambioPorcentajePrecio("porcent_precio5", "ProductoEditar");
                            });
                        }}
                    />
                </div>
                <div className="col-sm-12 col-md-2 col-lg-2 form-group">
                    {nombres_precios ? (
                        <label htmlFor="precio2">
                            {conf_porcentaje_precio && <span className="mr-2">%</span>}
                            {nombres_precios.nombre_precio2}
                            {conf_porcentaje_precio && (
                                <span className="ml-2 negro-dark2">
                                    (<RCurrency value={precio2Value ? parseFloat(precio2Value) : 0} />)
                                </span>
                            )}
                        </label>
                    ) : (
                        <label htmlFor="precio2">
                            {conf_porcentaje_precio && <span className="mr-2">%</span>}
                            Precio 2
                            {conf_porcentaje_precio && (
                                <span className="ml-2 negro-dark2">
                                    (<RCurrency value={precio2Value ? parseFloat(precio2Value) : 0} />)
                                </span>
                            )}
                        </label>
                    )}
                    {conf_porcentaje_precio ? (
                        <Field
                            name="porcent_precio2"
                            component={renderPorcentaje}
                            decimalScale={2}
                            type="number"
                            className="form-control"
                            onChange={(event) => {
                                setTimeout(() => {
                                    cambioPorcentajePrecio("porcent_precio2", "ProductoEditar");
                                });
                            }}
                        />
                    ) : (
                        <Field
                            name="precio2"
                            component={renderCurrency}
                            decimalScale={2}
                            type="number"
                            className="form-control"
                            onChange={(event) => {
                                setTimeout(() => {
                                    cambioPorcentajePrecio("precio2", "ProductoEditar");
                                });
                            }}
                        />
                    )}
                </div>
                <div className="col-sm-12 col-md-2 col-lg-2 form-group">
                    {nombres_precios ? (
                        <label htmlFor="precio3">
                            {conf_porcentaje_precio && <span className="mr-2">%</span>}
                            {nombres_precios.nombre_precio3}
                            {conf_porcentaje_precio && (
                                <span className="ml-2 negro-dark2">
                                    (<RCurrency value={precio3Value ? parseFloat(precio3Value) : 0} />)
                                </span>
                            )}
                        </label>
                    ) : (
                        <label htmlFor="precio3">
                            {conf_porcentaje_precio && <span className="mr-2">%</span>}
                            Precio 3
                            {conf_porcentaje_precio && (
                                <span className="ml-2 negro-dark2">
                                    (<RCurrency value={precio3Value ? parseFloat(precio3Value) : 0} />)
                                </span>
                            )}
                        </label>
                    )}
                    {conf_porcentaje_precio ? (
                        <Field
                            name="porcent_precio3"
                            component={renderPorcentaje}
                            decimalScale={2}
                            type="number"
                            className="form-control"
                            onChange={(event) => {
                                setTimeout(() => {
                                    cambioPorcentajePrecio("porcent_precio3", "ProductoEditar");
                                });
                            }}
                        />
                    ) : (
                        <Field
                            name="precio3"
                            component={renderCurrency}
                            decimalScale={2}
                            type="number"
                            className="form-control"
                            onChange={(event) => {
                                setTimeout(() => {
                                    cambioPorcentajePrecio("precio3", "ProductoEditar");
                                });
                            }}
                        />
                    )}
                </div>
                <div className="col-sm-12 col-md-2 col-lg-2 form-group">
                    {nombres_precios ? (
                        <label htmlFor="precio4">
                            {conf_porcentaje_precio && <span className="mr-2">%</span>}
                            {nombres_precios.nombre_precio4}
                            {conf_porcentaje_precio && (
                                <span className="ml-2 negro-dark2">
                                    (<RCurrency value={precio4Value ? parseFloat(precio4Value) : 0} />)
                                </span>
                            )}
                        </label>
                    ) : (
                        <label htmlFor="precio4">
                            {conf_porcentaje_precio && <span className="mr-2">%</span>}
                            Precio 4
                            {conf_porcentaje_precio && (
                                <span className="ml-2 negro-dark2">
                                    (<RCurrency value={precio4Value ? parseFloat(precio4Value) : 0} />)
                                </span>
                            )}
                        </label>
                    )}
                    {conf_porcentaje_precio ? (
                        <Field
                            name="porcent_precio4"
                            component={renderPorcentaje}
                            decimalScale={2}
                            type="number"
                            className="form-control"
                            onChange={(event) => {
                                setTimeout(() => {
                                    cambioPorcentajePrecio("porcent_precio4", "ProductoEditar");
                                });
                            }}
                        />
                    ) : (
                        <Field
                            name="precio4"
                            component={renderCurrency}
                            decimalScale={2}
                            type="number"
                            className="form-control"
                            onChange={(event) => {
                                setTimeout(() => {
                                    cambioPorcentajePrecio("precio4", "ProductoEditar");
                                });
                            }}
                        />
                    )}
                </div>
                <div className="col-sm-12 col-md-2 col-lg-2 form-group">
                    {nombres_precios ? (
                        <label htmlFor="precio5">
                            {conf_porcentaje_precio && <span className="mr-2">%</span>}
                            {nombres_precios.nombre_precio5}
                            {conf_porcentaje_precio && (
                                <span className="ml-2 negro-dark2">
                                    (<RCurrency value={precio5Value ? parseFloat(precio5Value) : 0} />)
                                </span>
                            )}
                        </label>
                    ) : (
                        <label htmlFor="precio5">
                            {conf_porcentaje_precio && <span className="mr-2">%</span>}
                            Precio 5
                            {conf_porcentaje_precio && (
                                <span className="ml-2 negro-dark2">
                                    (<RCurrency value={precio5Value ? parseFloat(precio5Value) : 0} />)
                                </span>
                            )}
                        </label>
                    )}
                    {conf_porcentaje_precio ? (
                        <Field
                            name="porcent_precio5"
                            component={renderPorcentaje}
                            decimalScale={2}
                            type="number"
                            className="form-control"
                            onChange={(event) => {
                                setTimeout(() => {
                                    cambioPorcentajePrecio("porcent_precio5", "ProductoEditar");
                                });
                            }}
                        />
                    ) : (
                        <Field
                            name="precio5"
                            component={renderCurrency}
                            decimalScale={2}
                            type="number"
                            className="form-control"
                            onChange={(event) => {
                                setTimeout(() => {
                                    cambioPorcentajePrecio("precio5", "ProductoEditar");
                                });
                            }}
                        />
                    )}
                </div>
                {tienda_onlineValue && (
                    <div className="col-sm-12 col-md-2 col-lg-2 form-group">
                        <label htmlFor="precio_online">Precio tienda online *</label>
                        <Field
                            name="precio_online"
                            component={renderCurrency}
                            decimalScale={2}
                            type="number"
                            className="form-control"
                        />
                    </div>
                )}
            </div>
            </div>
 
        </div>
    );
};

const PrecioSucursalSection = ({readOnlyMode = false, onNext, onPrevious, canGoNext, canGoPrevious, sucursales, sucursal, changeSucursal, sucursal_activo, nombres_precios, changeSucursalActivo, conf_porcentaje_precio, cambioPorcentajePrecio, precios_sucursalValue }) => {
    
    return (
        <div className="section-panel">
            <div className="section-header">
                <h4>Precio Sucursal</h4>
                {!readOnlyMode && (
                <div className="section-actions">
                    <button 
                        type="button" 
                        className="btn btn-secondary"
                        onClick={() => {
                            console.log('Botón Regresar clickeado - Precio Sucursal');
                            onPrevious();
                        }}
                        disabled={!canGoPrevious}
                    >
                        Regresar
                    </button>
                    <button 
                        type="button" 
                        className="btn btn-primary"
                        onClick={() => {
                            console.log('Botón Siguiente clickeado - Precio Sucursal');
                            onNext();
                        }}
                        disabled={!canGoNext}
                    >
                        Siguiente
                    </button>
                </div>
                )}
            </div>
            
            <div className="row row-fields">
                <div className="col-12 col-md-12 col-lg-12 form-group">
                    <label>Precios por sucursal</label>
                    <FieldArray
                        name="precios_sucursal"
                        component={preciosSucursal}
                        sucursales={sucursales}
                        sucursal={sucursal}
                        changeSucursal={changeSucursal}
                        sucursal_activo={sucursal_activo}
                        nombres_precios={nombres_precios}
                        changeSucursalActivo={changeSucursalActivo}
                        conf_porcentaje_precio={conf_porcentaje_precio}
                        cambioPorcentajePrecio={cambioPorcentajePrecio}
                        precios_sucursalValue={precios_sucursalValue}
                        nombreFormulario="ProductoEditar"
                        readOnlyMode={readOnlyMode}
                    />
                </div>
            </div>
        </div>
    );
};



const PropiedadesProductoSection = ({ readOnlyMode = false, onNext, onPrevious, canGoNext, canGoPrevious, inventariableValue, alertaValue, producto, descontinuar, reactivar   }) => {
    
    //Soporte de videos
    const [videos, setVideos] = useState(null);
        
    const openVideoModal = function(videos){
        setVideos(videos);
    };
        
    const closeVideoModal = function(){
        setVideos(null);
    };



    return (
        <div className="section-panel">
            <div className="section-header">
                <h4>Propiedades de producto</h4>
                {!readOnlyMode && (
                <div className="section-actions">
                    <button 
                        type="button" 
                        className="btn btn-secondary"
                        onClick={() => {
                            console.log('Botón Regresar clickeado - Propiedades');
                            onPrevious();
                        }}
                        disabled={!canGoPrevious}
                    >
                        Regresar
                    </button>
                    <button 
                        type="button" 
                        className="btn btn-primary"
                        onClick={() => {
                            console.log('Botón Siguiente clickeado - Propiedades');
                            onNext();
                        }}
                        disabled={!canGoNext}
                    >
                        Siguiente
                    </button>
                </div>
                )}
            </div>
            
            <div className={readOnlyMode ? "read-only-wrapper" : ""}>
            <div className="row row-fields">
                <div className="col-12 mb-4">
                    <div className="setting-row">
                        <div className="setting-toggle">
                            <label className="switch">
                                <Field
                                    name="descontinuado"
                                    component={({ input }) => (
                                        <input
                                        {...input}
                                        type="checkbox"
                                        checked={!!input.value}
                                        onChange={(e) => {
                                            const nuevoValor = e.target.checked;

                                            if (nuevoValor) {
                                            mostrarSwalDescontinuar(() => {
                                                descontinuar(producto.id);
                                                input.onChange(true); //  solo cambia si confirma
                                            });
                                            } else {
                                            mostrarSwalReactivar(() => {
                                                reactivar(producto.id);
                                                input.onChange(false); //  solo cambia si confirma
                                            });
                                            }
                                        }}
                                        />
                                    )}
                                    />
                                <span className="slider round"></span>
                            </label>
                        </div>

                        <div className="setting-content">
                            <h6 className="mb-1">Descontinuar producto</h6>
                            <small className="text-muted mb-0">
                                Cuando descontinúas un producto, ya no podrás usarlo en operaciones del sistema
                                (como ventas o compras). Sin embargo, puedes reactivarlo en cualquier momento
                                si decides volver a usarlo.
                            </small>
                        </div>
                    </div>

                    <hr />
                </div>

                <br />

                <div className="w-100 text-muted small mb-2">
                    Define cómo se gestionará este producto dentro del sistema. Aquí puedes indicar si estará disponible para la venta, si llevará control de inventario y si deseas recibir alertas cuando las existencias sean bajas.
                </div>
                            
                <div className="col-md-6 mb-4">
                    <SettingToggle
                        name="vendible"
                        title="Vendible"
                        description="Aparecerá en el punto de venta"
                        videos={["https://res.cloudinary.com/dk72mdawi/video/upload/v1773272110/Vendible_kkanef.mp4"]}
                        onOpenModal={openVideoModal}
                        disabled={readOnlyMode}
                    />
                </div>

                <div className="col-md-6 mb-4">
                    <SettingToggle
                        name="inventariable"
                        title="Inventariable"
                        description="El producto llevará registro de cuántas unidades tiene disponibles"
                        videos={["https://res.cloudinary.com/dk72mdawi/video/upload/v1773272241/Inventareable_tpt9td.mp4"]}
                        onOpenModal={openVideoModal}
                        disabled={readOnlyMode}
                    />
                </div>

                {Boolean(inventariableValue) && (
                    <div className="col-md-6 mb-4">
                        <SettingToggle
                            name="alertar"
                            title="Alerta"
                            description="Cuando el producto tiene pocas existencias, el sistema mostrará una alerta"
                            videos={["https://res.cloudinary.com/dk72mdawi/video/upload/v1773272326/Alerta_nz7gpn.mp4"]}
                            onOpenModal={openVideoModal}
                            disabled={readOnlyMode}
                        />
                    </div>
                )}

                {Boolean(alertaValue) && (
                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                        <label>Mínimo cantidad existencia *</label>
                        <Field
                            name="minimo_existencias"
                            component={renderNumber}
                            type="number"
                            className="form-control"
                            disabled={readOnlyMode}
                        />
                    </div>
                )}
            </div>
            </div>

            {videos && (
                <ModalVideo
                    videos={videos}
                    onClose={closeVideoModal}
                />
            )}

        </div>
    );
};

const ManejoProductoSection = ({readOnlyMode = false, categoriaSelect, categorias_expanded, categorias_seleccionados, setCategoriasExpanded, asignarCategoria, categorias, conf_tienda_online,  onNext, onPrevious, canGoNext, canGoPrevious, inventariableValue, tienda_onlineValue, cambioTipoProducto, cambioSeleccionUnidad, seleccion_unidades_medida, unidadDeMedidaValue, tipoProductoValue, fraccionadoValue , unidades_medida }) => {
    console.log('Unidades de medida:', unidades_medida);
    return (
        <div className="section-panel">
            <div className="section-header">
                <h4>Manejo de producto</h4>
                {!readOnlyMode && (
                <div className="section-actions">
                    <button 
                        type="button" 
                        className="btn btn-secondary"
                        onClick={() => {
                            console.log('Botón Regresar clickeado - Manejo');
                            onPrevious();
                        }}
                        disabled={!canGoPrevious}
                    >
                        Regresar
                    </button>
                    <button 
                        type="button" 
                        className="btn btn-primary"
                        onClick={() => {
                            console.log('Botón Siguiente clickeado - Manejo');
                            onNext();
                        }}
                        disabled={!canGoNext}
                    >
                        Siguiente
                    </button>
                </div>
                )}
            </div>
            
            <div className={`section-panel ${readOnlyMode ? "read-only-wrapper" : ""}`}>
            {Boolean(inventariableValue) && 
                !tienda_onlineValue && 
                ["1000", "2000", "3000"].indexOf(String(tipoProductoValue)) !== -1 ? (
                <div className="row">
                    <div className="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-center w-100 ml-3 mt-3">
                        
                        {/* Contenedor del Select (Estilo de Crear) */}
                        <div className="d-flex flex-column flex-lg-row flex-grow-0">
                            <Field
                                name="tipo_producto"
                                component="select"
                                className="form-control custom-select negro-dark2"
                                value={tipoProductoValue || ""}
                                onChange={(e) => {
                                    const valor = e.target.value;
                                    cambioTipoProducto(valor, "editar");
                                    // Mantenemos la lógica de editar: ocultar unidades al cambiar
                                    cambioSeleccionUnidad(false); 
                                }}
                            >
                                <option value="" disabled>Seleccione una opción</option>
                                {/* Agregamos todas las opciones del código de Editar */}
                                <option value="1000">Peso</option>
                                <option value="2000">Capacidad</option>
                                <option value="3000">Longitud</option>
                            </Field>
                        </div>

                        {/* Botón condicional (Lógica de Editar) */}
                        {/* Se convierte a String por seguridad, recordando que el JS de tu proyecto es antiguo */}
                        {["1000", "2000", "3000"].indexOf(String(tipoProductoValue)) !== -1 && (
                            <div className="mt-3 mt-lg-0 ml-lg-3">
                                <button
                                    type="button"
                                    className="btn btn-outline-dark fnt-md-16 fnt-sm-12"
                                    style={{ marginTop: "-15px" }}
                                    onClick={() => cambioSeleccionUnidad(!seleccion_unidades_medida)}
                                >
                                    <span>Seleccionar unidades de medidas</span>
                                </button>
                            </div>
                        )}
                        
                    </div>
                </div>
            ) : null}
            
            {tienda_onlineValue && conf_tienda_online && (
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <label htmlFor="categorias">
                                                            Seleccione la categoría
                                                        </label>
                                                        <br />
                                                        <small className="fnt-12">
                                                            Puede seleccionar hasta un
                                                            máximo de 3 categorías
                                                        </small>
                                                    </div>
                                                    <TreeCategoria
                                                        categorias={categorias}
                                                        asignarCategoria={asignarCategoria}
                                                        setCategoriasExpanded={
                                                            setCategoriasExpanded
                                                        }
                                                        categorias_seleccionados={
                                                            categorias_seleccionados
                                                        }
                                                        categorias_expanded={
                                                            categorias_expanded
                                                        }
                                                    />
                                                    {categoriaSelect && (
                                                        <div className="invalid-feedback d-block my-2 fnt-10 ml-2">
                                                            Campo requerido
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                <div className="d-flex flex-column">
                                    {Boolean(inventariableValue) && !tienda_onlineValue && (
                                        <div className="w-100">

                                            {/* SWITCH TIENDA ONLINE */}
                                                                    {conf_tienda_online && tipoProductoValue =="1" && (
                                                                        <div className="form-group">
                                                                            <label htmlFor="tienda_online">Publicar en tienda online</label>
                                                                            <br />
                                                                            <label className="switch">
                                                                                <Field
                                                                                    name="tienda_online"
                                                                                    component="input"
                                                                                    type="checkbox"
                                                                                />
                                                                                <span className="slider round"></span>
                                                                            </label>
                                                                        </div>
                                                                    )}
                                            {/* PRODUCTO SIMPLE */}
                                            {tipoProductoValue == "1" && (
                                                <div className="d-flex flex-column text-center justify-content-center align-items-center">
                                                    <h5 className="font-weight-normal negro-dark2 mt-3 mb-5 fnt-08-rem">
                                                        No aplica ningún tratamiento
                                                        especial
                                                    </h5>
                                                    <img
                                                        src={icons.producto_simple}
                                                        alt="producto_simple"
                                                        className="img-fluid"
                                                        style={{ maxWidth: "200px" }}
                                                    />
                                                </div>
                                            )}
                                            {/* PRODUCTO FRACCIONADO */}
                                            {tipoProductoValue == "100" && (
                                                <div className="d-flex flex-column text-center justify-content-center align-items-center">
                                                    <h5 className="font-weight-normal negro-dark2 mt-3 fnt-08-rem">
                                                        Esta opción te permite trabajar por
                                                        fracciones, por ejemplo: Las
                                                        farmacias que venden sus productos
                                                        individuales.
                                                    </h5>
                                                    <h5 className="font-weight-normal negro-dark2 mb-5 fnt-08-rem">
                                                        Observa la siguiente imagen
                                                    </h5>
                                                    <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center">
                                                        <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                            <h5 className="negro-dark font-weight-bold">
                                                                Fardo
                                                            </h5>
                                                            <img
                                                                src={icons.fraccion_fardo}
                                                                alt="producto_simple"
                                                                className="img-fluid"
                                                                style={{
                                                                    maxWidth: "150px",
                                                                }}
                                                            />
                                                        </div>
                                                        <img
                                                            className="rotar-90-deg"
                                                            src={icons.flecha_derecha}
                                                            alt="flecha-derecha"
                                                            style={{
                                                                width: "50px",
                                                                height: "50px",
                                                            }}
                                                        />
                                                        <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                            <h5 className="negro-dark font-weight-bold">
                                                                Caja
                                                            </h5>
                                                            <img
                                                                src={icons.fraccion_caja}
                                                                alt="producto_simple"
                                                                className="img-fluid"
                                                                style={{
                                                                    maxWidth: "150px",
                                                                }}
                                                            />
                                                        </div>
                                                        <img
                                                            className="rotar-90-deg"
                                                            src={icons.flecha_derecha}
                                                            alt="flecha-derecha"
                                                            style={{
                                                                width: "50px",
                                                                height: "50px",
                                                            }}
                                                        />
                                                        <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                            <h5 className="negro-dark font-weight-bold">
                                                                Blister
                                                            </h5>
                                                            <img
                                                                src={icons.fraccion_blister}
                                                                alt="producto_simple"
                                                                className="img-fluid"
                                                                style={{
                                                                    maxWidth: "150px",
                                                                }}
                                                            />
                                                        </div>
                                                        <img
                                                            className="rotar-90-deg"
                                                            src={icons.flecha_derecha}
                                                            alt="flecha-derecha"
                                                            style={{
                                                                width: "50px",
                                                                height: "50px",
                                                            }}
                                                        />
                                                        <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                            <h5 className="negro-dark font-weight-bold">
                                                                Pastillas
                                                            </h5>
                                                            <img
                                                                src={
                                                                    icons.fraccion_pastilla
                                                                }
                                                                alt="producto_simple"
                                                                className="img-fluid"
                                                                style={{
                                                                    maxWidth: "150px",
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
            
                                            {/* PRODUCTO PESO */}
                                            {tipoProductoValue == "1000" && (
                                                <div className="d-flex flex-column text-center justify-content-center align-items-center">
                                                    {!seleccion_unidades_medida ? (
                                                        <div className="w-100">
                                                            <h5 className="font-weight-normal negro-dark2 mt-3 fnt-08-rem">
                                                                Esta opción te permite
                                                                comprar y vender en medidas
                                                                de peso, por ejemplo:
                                                                comprar 300 libras y vender
                                                                15.38 libras.
                                                            </h5>
                                                            <h5 className="font-weight-normal negro-dark2 mb-5 fnt-08-rem">
                                                                Observa la siguiente imagen
                                                            </h5>
                                                            <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center">
                                                                <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                                    <h5 className="negro-dark2 font-weight-bold">
                                                                        Quintal
                                                                    </h5>
                                                                    <img
                                                                        src={
                                                                            icons.producto_peso_saco
                                                                        }
                                                                        alt="producto_simple"
                                                                        className="img-fluid"
                                                                        style={{
                                                                            maxWidth:
                                                                                "150px",
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="linea-vertical rotar-90-deg"></div>
                                                                {/* <img className="rotar-90-deg" src={icons.flecha_derecha_naranja} alt="flecha-derecha" style={{width:"50px", height:"50px"}}/> */}
                                                                <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                                    <h5 className="negro-dark2 font-weight-bold">
                                                                        Libra
                                                                    </h5>
                                                                    <img
                                                                        src={
                                                                            icons.producto_peso_libra
                                                                        }
                                                                        alt="producto_simple"
                                                                        className="img-fluid"
                                                                        style={{
                                                                            maxWidth:
                                                                                "150px",
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="w-100 mb-4">
                                                            <h5 className="font-weight-normal negro-dark2 mt-3 mb-5 fnt-08-rem">
                                                                Elige las medidas que deseas
                                                                comprar y vender tu producto
                                                            </h5>
                                                            <div className="ml30 mr30 d-flex flex-column flex-lg-row justify-content-center align-items-start align-items-lg-center">
                                                                {unidades_medida.map(
                                                                    (unidad, index) => {
                                                                        return (
                                                                            <div
                                                                                className="radio c-radio c-radio-nofont d-flex"
                                                                                key={index}
                                                                            >
                                                                                <label className="negro-dark2 font-weight-normal">
                                                                                    <Field
                                                                                        name="unidad_de_medida"
                                                                                        component="input"
                                                                                        type="radio"
                                                                                        checked={
                                                                                            unidad.id ==
                                                                                            unidadDeMedidaValue
                                                                                        }
                                                                                        value={
                                                                                            unidad.id
                                                                                        }
                                                                                    />
                                                                                    <span />
                                                                                    {
                                                                                        unidad.nombre
                                                                                    }
                                                                                    &nbsp;&nbsp;
                                                                                </label>
                                                                            </div>
                                                                            // <div className="checkbox c-checkbox" key={index}>
                                                                            //     <label className="needsclick">
                                                                            //         <input type="checkbox" checked={unidad.seleccionado} onChange={(e) => {
                                                                            //             changeUnidadesMedidas(!unidad.seleccionado, unidad.id);
                                                                            //         }} />
                                                                            //         <span className="fa fa-check" />
                                                                            //         {unidad.nombre}&nbsp;&nbsp;
                                                                            //     </label>
                                                                            // </div>
                                                                        );
                                                                    }
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
            
                                            {/* PRODUCTO CAPACIDAD */}
                                            {tipoProductoValue == "2000" && (
                                                <div className="d-flex flex-column text-center justify-content-center align-items-center">
                                                    {!seleccion_unidades_medida ? (
                                                        <div className="w-100">
                                                            <h5 className="font-weight-normal negro-dark2 mt-3 fnt-08-rem">
                                                                Esta opción te permite
                                                                comprar y vender en medidas
                                                                de capacidad, por ejemplo:
                                                                comprar 300 litros y vender
                                                                10.35 litros.
                                                            </h5>
                                                            <h5 className="font-weight-normal negro-dark2 mb-5 fnt-08-rem">
                                                                Observa la siguiente imagen
                                                            </h5>
                                                            <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center">
                                                                <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                                    <h5 className="negro-dark font-weight-bold">
                                                                        Galón
                                                                    </h5>
                                                                    <img
                                                                        src={
                                                                            icons.producto_capacidad_galon
                                                                        }
                                                                        alt="producto_simple"
                                                                        className="img-fluid"
                                                                        style={{
                                                                            maxWidth:
                                                                                "150px",
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="linea-vertical rotar-90-deg"></div>
                                                                {/* <img className="rotar-90-deg" src={icons.flecha_derecha_naranja} alt="flecha-derecha" style={{width:"50px", height:"50px"}}/> */}
                                                                <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                                    <h5 className="negro-dark font-weight-bold">
                                                                        Litro
                                                                    </h5>
                                                                    <img
                                                                        src={
                                                                            icons.producto_capacidad_litro
                                                                        }
                                                                        alt="producto_simple"
                                                                        className="img-fluid"
                                                                        style={{
                                                                            maxWidth:
                                                                                "150px",
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="linea-vertical rotar-90-deg"></div>
                                                                {/* <img className="rotar-90-deg" src={icons.flecha_derecha_naranja} alt="flecha-derecha" style={{width:"50px", height:"50px"}}/> */}
                                                                <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                                    <h5 className="negro-dark font-weight-bold">
                                                                        Mililitros
                                                                    </h5>
                                                                    <img
                                                                        src={
                                                                            icons.producto_capacidad_mililitro
                                                                        }
                                                                        alt="producto_simple"
                                                                        className="img-fluid"
                                                                        style={{
                                                                            maxWidth:
                                                                                "150px",
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="w-100 mb-4">
                                                            <h5 className="font-weight-normal negro-dark2 mt-3 mb-5 fnt-08-rem">
                                                                Elige las medidas que deseas
                                                                comprar y vender tu producto
                                                            </h5>
                                                            <div className="ml30 mr30 d-flex flex-column flex-lg-row justify-content-center align-items-start align-items-lg-center">
                                                                {unidades_medida.map(
                                                                    (unidad, index) => {
                                                                        return (
                                                                            <div
                                                                                className="radio c-radio c-radio-nofont d-flex"
                                                                                key={index}
                                                                            >
                                                                                <label className="negro-dark2 font-weight-normal">
                                                                                    <Field
                                                                                        name="unidad_de_medida"
                                                                                        component="input"
                                                                                        type="radio"
                                                                                        checked={
                                                                                            unidad.id ==
                                                                                            unidadDeMedidaValue
                                                                                        }
                                                                                        value={
                                                                                            unidad.id
                                                                                        }
                                                                                    />
                                                                                    <span />
                                                                                    {
                                                                                        unidad.nombre
                                                                                    }
                                                                                    &nbsp;&nbsp;
                                                                                </label>
                                                                            </div>
                                                                            // <div className="checkbox c-checkbox" key={index}>
                                                                            //     <label className="needsclick">
                                                                            //         <input type="checkbox" checked={unidad.seleccionado} onChange={(e) => {
                                                                            //             changeUnidadesMedidas(!unidad.seleccionado, unidad.id);
                                                                            //         }} />
                                                                            //         <span className="fa fa-check" />
                                                                            //         {unidad.nombre}&nbsp;&nbsp;
                                                                            //     </label>
                                                                            // </div>
                                                                        );
                                                                    }
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
            
            
            
                                            {/* PRODUCTO LONGITUD */}
                                            {tipoProductoValue == "3000" && (
                                                <div className="d-flex flex-column text-center justify-content-center align-items-center">
                                                    {!seleccion_unidades_medida ? (
                                                        <div className="w-100">
                                                            <h5 className="font-weight-normal negro-dark2 mt-3 fnt-08-rem">
                                                                Esta opción te permite
                                                                comprar y vender en medidas
                                                                de longitud, por ejemplo:
                                                                comprar 300 yardas y vender
                                                                10.35 yardas.
                                                            </h5>
                                                            <h5 className="font-weight-normal negro-dark2 mb-5 fnt-08-rem">
                                                                Observa la siguiente imagen
                                                            </h5>
                                                            <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center">
                                                                <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                                    <h5 className="negro-dark font-weight-bold">
                                                                        Metro
                                                                    </h5>
                                                                    <img
                                                                        src={
                                                                            icons.producto_longitud_metro
                                                                        }
                                                                        alt="producto_simple"
                                                                        className="img-fluid"
                                                                        style={{
                                                                            maxWidth:
                                                                                "150px",
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="linea-vertical rotar-90-deg"></div>
                                                                {/* <img className="rotar-90-deg" src={icons.flecha_derecha_naranja} alt="flecha-derecha" style={{width:"50px", height:"50px"}}/> */}
                                                                <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-2">
                                                                    <h5 className="negro-dark font-weight-bold">
                                                                        Yarda
                                                                    </h5>
                                                                    <img
                                                                        src={
                                                                            icons.producto_longitud_yarda
                                                                        }
                                                                        alt="producto_simple"
                                                                        className="img-fluid"
                                                                        style={{
                                                                            maxWidth:
                                                                                "150px",
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="w-100 mb-4">
                                                            <h5 className="font-weight-normal negro-dark2 mt-3 mb-5 fnt-08-rem">
                                                                Elige las medidas que deseas
                                                                comprar y vender tu producto
                                                            </h5>
                                                            <div className="ml30 mr30 d-flex flex-column flex-lg-row justify-content-center align-items-start align-items-lg-center">
                                                                {unidades_medida.map(
                                                                    (unidad, index) => {
                                                                        return (
                                                                            <div
                                                                                className="radio c-radio c-radio-nofont d-flex"
                                                                                key={index}
                                                                            >
                                                                                <label className="negro-dark2 font-weight-normal">
                                                                                    <Field
                                                                                        name="unidad_de_medida"
                                                                                        component="input"
                                                                                        type="radio"
                                                                                        checked={
                                                                                            unidad.id ==
                                                                                            unidadDeMedidaValue
                                                                                        }
                                                                                        value={
                                                                                            unidad.id
                                                                                        }
                                                                                    />
                                                                                    <span />
                                                                                    {
                                                                                        unidad.nombre
                                                                                    }
                                                                                    &nbsp;&nbsp;
                                                                                </label>
                                                                            </div>
                                                                        );
                                                                    }
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
            
                                        </div>
                                    )}
                                </div>     

                    {/* SECCION DE CRUD DE FRACCIONES */}
                    {Boolean(fraccionadoValue) &&
                    Boolean(inventariableValue) ? (
                        <div className="row row-fields">
                            <FraccionesComponent />
                        </div>
                    ) : null}

                </div>

        </div>
    );
};

const ResumenSection = ({ 
    onPrevious, 
    onNext, 
    canGoPrevious, 
    tipoProducto, // El key: 'simple', 'medida' o 'fraccionado'
    unidades_medida,
    goToSection,
    invalid,
    handleSubmit,
    ...props 
}) => {
    // Obtenemos el listado de secciones que corresponden a este tipo
    // Filtramos 'resumen' para no renderizarnos a nosotros mismos infinitamente
    var seccionesAMostrar = SECTIONS_BY_TIPO[tipoProducto] || [];


    const handleFinish = () => {
            if (invalid) {
    
                handleSubmit(() => {})(); // fuerza validación visual
    
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "error",
                    title: "Hay campos obligatorios sin completar",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                });
    
                return;
            }
    
            onNext();
    };
    
    return (
        <div className="section-panel resumen-dinamico">
            <div className="section-header border-bottom mb-4">
                <div>
                    <h4>Resumen de Configuración</h4>
                    <p className="text-muted fnt-12">Revisa cada sección antes de finalizar el registro.</p>
                </div>
            </div>

            <div className="resumen-content">
                {seccionesAMostrar.map(function(sectionId) {
                    // No renderizamos la sección de resumen dentro del resumen
                    if (sectionId === "resumen") return null;

                    return (
                        <div key={sectionId} className="resumen-block mb-5 pb-4 border-bottom">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <div>
                                    <span className="badge badge-warning mr-2">Sección</span>
                                </div>

                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => goToSection(sectionId)}
                                >
                                    <i className="fa fa-pencil mr-1"></i>
                                    Editar
                                </button>
                            </div>
                            
                            {/* Renderizado Condicional de los componentes originales */}
                            {sectionId === "datos-generales" && (
                                <DatosGeneralesSection readOnlyMode {...props} onNext={null} onPrevious={null} />
                            )}
                            {sectionId === "precios-generales" && (
                                <PreciosGeneralesSection readOnlyMode {...props} onNext={null} onPrevious={null} />
                            )}
                            {sectionId === "precio-sucursal" && (
                                <PrecioSucursalSection readOnlyMode {...props} onNext={null} onPrevious={null} />
                            )}
                            {sectionId === "propiedades-producto" && (
                                <PropiedadesProductoSection readOnlyMode {...props} onNext={null} onPrevious={null} />
                            )}
                            {sectionId === "manejo-producto" && (
                                <ManejoProductoSection readOnlyMode {...props} unidades_medida={unidades_medida} onNext={null} onPrevious={null} />
                            )}
                        </div>
                    );
                })}
            </div>

            <div className="alert alert-warning text-center">
                <strong>¿Todo correcto?</strong> Si necesitas cambiar algo, puedes usar el botón <strong>"Regresar"</strong>, el menú lateral o el botón <strong>"Editar"</strong> de cada sección en el resumen.
            </div>

            <div className="section-actions justify-content-between">
                <button 
                    type="button" 
                    className="btn btn-secondary"
                    onClick={onPrevious}
                    disabled={!canGoPrevious}
                >
                    Regresar
                </button>
                <button 
                    type="button" 
                    className="btn btn-primary"
                    onClick={handleFinish}
                >
                    <i className="fa fa-check-circle mr-2"></i> Finalizar y Guardar
                </button>
            </div>
        </div>
    );
};

let ProductoForm = reduxForm({
    form: "ProductoEditar",
    validate,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
})(Form);

const selector = formValueSelector("ProductoEditar");

ProductoForm = connect((state) => {
    const store = state.producto;
    const form = state.form.ProductoEditar;
    let categoriaSelect = false;
    const tienda_onlineValue = selector(state, "tienda_online");
    if (form && tienda_onlineValue) {
        const { submitFailed, submitSucceeded } = form;
        categoriaSelect = store.categorias_seleccionados.length <= 0 && (submitFailed || submitSucceeded);
    }

    const tipoProductoValue = selector(state, "tipo_producto");
    const fraccionadoValue = parseInt(tipoProductoValue) == 100 ? true : false;
    const inventariableValue = selector(state, "inventariable");
    const alertaValue = selector(state, "alertar");
    const unidadDeMedidaValue = selector(state, "unidad_de_medida");
    const kilataje = selector(state, "kilataje");
    const familiaValue = selector(state, "familia");
    const precio2Value = selector(state, "precio2");
    const precio3Value = selector(state, "precio3");
    const precio4Value = selector(state, "precio4");
    const precio5Value = selector(state, "precio5");
    const precios_sucursalValue = selector(state, "precios_sucursal");
    
    return {
        tipoProductoValue,
        fraccionadoValue,
        inventariableValue,
        alertaValue,
        unidadDeMedidaValue,
        tienda_onlineValue,
        categoriaSelect,
        precio2Value,
        precio3Value,
        precio4Value,
        precio5Value,
        precios_sucursalValue,
        kilataje,
        familiaValue,
        producto: store.producto,
        initialValues: {
            ...store.producto,
            codigos_barras: store.producto && store.producto.codigos_barras && store.producto.codigos_barras.length
                ? store.producto.codigos_barras
                : [''],
            vendible: store.producto && store.producto.vendible !== undefined 
                ? store.producto.vendible 
                : true,
            precios_sucursal: store.producto && store.producto.precios_sucursal 
                ? store.producto.precios_sucursal 
                : [],
            precio: store.producto && store.producto.precio 
                ? store.producto.precio 
                : 0,
        },
    };
})(ProductoForm);

export default ProductoForm; 